<template>
<div class="ui vertical segment">
<app-header v-if="showMenu" ></app-header>
<div class="ui container">

<br />
<br />

<div class="ui message">
  <div class="header">
    You are not mapped to any  modules,
  </div>
  <br />
    <li> Please contact System Administrator to get the access.</li>


</div>






</div>
</div>

</template>
<script>
import Header from '@/components/Header.vue';
export default {
    components: {
    appHeader: Header
    
  },
    data () {
      return {
            showMenu :true
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/auth/Noaccess.vue